/* Merry Christmas — singurul JS al temei (defer, fără biblioteci).
   Banda rotită la 5 s · căutare cu sugestii · foi de jos / meniu · cronometre spre date reale · termenul de Crăciun ·
   Adaugă în coș (+ coșul care sare, bara de jos) · galeria · „Vezi mai multe” (Section Rendering API) · coșul fără reîncărcare.
   La prefers-reduced-motion: fără rotiri și fără animații.
   Sursa: ~/API emag/magazin_nou/craciun/tema/src/assets/mc.js */
(function () {
  "use strict";
  var d = document;
  var mmRed = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  function bani(c) {
    var s = (Math.round(c) / 100).toFixed(2).split(".");
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return s[0] + "," + s[1] + " lei";
  }
  /* ——— 0. banda de sus: mesajele valabile azi, rotite ——— */
  function banda() {
    $$("[data-rot]").forEach(function (rot) {
      var acum = Date.now() / 1000;
      var m = $$(".mc-band__m", rot).filter(function (el) {
        var de = +el.getAttribute("data-de") || 0, pana = +el.getAttribute("data-pana") || 0;
        var ok = !(de && acum < de) && !(pana && acum > pana);
        el.hidden = !ok;
        el.classList.remove("is-on");
        return ok;
      });
      if (!m.length) return;
      var i = 0;
      m[0].classList.add("is-on");
      if (m.length < 2 || mmRed) return;
      var pauza = false, sec = (+rot.getAttribute("data-rot") || 5) * 1000;
      rot.addEventListener("mouseenter", function () { pauza = true; });
      rot.addEventListener("mouseleave", function () { pauza = false; });
      setInterval(function () {
        if (pauza || d.hidden) return;
        m[i].classList.remove("is-on");
        i = (i + 1) % m.length;
        m[i].classList.add("is-on");
      }, sec);
    });
  }

  /* ——— dialoguri: meniul și foile de jos. La deschidere se pune o intrare în istoric, ca butonul Înapoi al telefonului
     să închidă foaia / sertarul în loc să plece de pe pagină (NN/g, foaia de jos). ——— */
  function deschide(dl, b) {
    if (!dl || !dl.showModal) return false;
    var tpl = dl.querySelector("template[data-tpl]"), corp = dl.querySelector("[data-tpl-corp]");
    if (tpl && corp && !corp.firstChild) { corp.appendChild(tpl.content.cloneNode(true)); if (dl.querySelector("[data-tc2]")) tc2Curent(dl); }
    if (dl.open) return true;
    dl.showModal();
    if (b) { b.setAttribute("aria-expanded", "true"); dl._btn = b; }
    try { history.pushState({ mcDlg: dl.id }, ""); dl._ist = true; } catch (e) {}
    return true;
  }
  window.addEventListener("popstate", function () {
    $$("dialog[open]").forEach(function (dl) { if (dl._ist) { dl._ist = false; dl.close(); } });
  });
  function dialoguri() {
    d.addEventListener("click", function (e) {
      var b = e.target.closest("[data-deschide]");
      if (b) {
        var dl = d.getElementById(b.getAttribute("data-deschide"));
        if (deschide(dl, b)) e.preventDefault();
        return;
      }
      var x = e.target.closest("[data-inchide]");
      if (x) { var dd = x.closest("dialog"); if (dd) dd.close(); return; }
      if (e.target.tagName === "DIALOG" && e.target.open) {
        var r = e.target.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
      }
    });
    $$("dialog.mc-sertar, dialog.mc-foaie").forEach(function (dl) {
      dl.addEventListener("close", function () {
        if (dl._btn) dl._btn.setAttribute("aria-expanded", "false");
        if (dl._ist) { dl._ist = false; try { if (history.state && history.state.mcDlg === dl.id) history.back(); } catch (e) {} }
      });
    });
    /* sertarul „Toate categoriile” pe 2 coloane: grupele din stânga schimbă panoul din dreapta */
    d.addEventListener("click", function (e) {
      var t = e.target.closest("[data-tc2-tab]"); if (!t) return;
      tc2Alege(t.closest("[data-tc2]"), t);
    });
  }
  function tc2Alege(r, t) {
    if (!r || !t) return;
    $$("[data-tc2-tab]", r).forEach(function (x) {
      var on = x === t; x.setAttribute("aria-selected", on ? "true" : "false");
      var p = d.getElementById(x.getAttribute("aria-controls")); if (p) p.hidden = !on;
    });
    var dr = $(".mc-tc2__dr", r); if (dr) dr.scrollTop = 0;
  }
  function tc2Curent(dl) {
    /* grupa paginii curente: panoul care are o legătură spre adresa de acum */
    var r = $("[data-tc2]", dl), cale = location.pathname.replace(/\/$/, "");
    $$(".mc-tc2__p a", r).some(function (a) {
      var u; try { u = new URL(a.href, location.href); } catch (e) { return false; }
      if (u.pathname.replace(/\/$/, "") !== cale || cale === "") return false;
      a.setAttribute("aria-current", "page");
      var p = a.closest(".mc-tc2__p"), t = p && $('[aria-controls="' + p.id + '"]', r);
      if (t) tc2Alege(r, t);
      return true;
    });
  }

  /* ——— căutarea: sugestiile rotite în câmp, căutările recente + populare la atingere, rezultate rapide ——— */
  function fara(s) { return String(s).normalize ? String(s).normalize("NFD").replace(/[\u0300-\u036f]/g, "") : String(s); }
  var dictCache = null;
  function dictionar() {
    if (dictCache) return dictCache;
    dictCache = {};
    var f = $("[data-sinonime]");
    (f ? f.getAttribute("data-sinonime") || "" : "").split(/\n|\r|;/).forEach(function (r) {
      var p = r.split("="); if (p.length < 2) return;
      var a = fara(p[0].trim().toLowerCase()), b = fara(p[1].trim().toLowerCase());
      if (a && b) dictCache[a] = b;
    });
    return dictCache;
  }
  /* „Instalații LED covoare” → „instalatie led covor”: fără diacritice (titlurile n-au diacritice) și cu pluralul din listă */
  function normalizeaza(q) {
    var dc = dictionar();
    return fara(q.toLowerCase()).replace(/[„”"]/g, " ").split(/\s+/).filter(Boolean).map(function (w) { return dc[w] || w; }).join(" ");
  }
  function recente() { try { return JSON.parse(localStorage.getItem("mc-cautari") || "[]"); } catch (e) { return []; } }
  function salveazaRecente(L) { try { localStorage.setItem("mc-cautari", JSON.stringify(L.slice(0, 8))); } catch (e) {} }
  function urlCautare(q) { return root + "search?type=product&options%5Bprefix%5D=last&q=" + encodeURIComponent(normalizeaza(q)); }
  function cautare() {
    $$("[data-cauta]").forEach(function (f) {
      var inp = $(".mc-cauta__in", f), lista = $("[data-predictiv]", f);
      var sug = [];
      try { sug = JSON.parse(inp.getAttribute("data-sugestii") || "[]"); } catch (e) {}
      function gol() {
        var rc = recente(), h = "";
        if (rc.length) {
          h += '<div class="mc-cauta__cap"><b>Căutările tale recente</b><button type="button" data-recente-sterge>Șterge istoricul</button></div><div class="mc-cauta__bule">';
          rc.forEach(function (q, i) {
            h += '<span class="mc-cauta__bula"><a href="' + urlCautare(q) + '"><svg class="mc-i" aria-hidden="true"><use href="#mc-i-ceas"/></svg>' + esc(q) + '</a><button type="button" data-recent-x="' + i + '" aria-label="Scoate „' + esc(q) + '” din istoric"><svg class="mc-i" aria-hidden="true"><use href="#mc-i-x"/></svg></button></span>';
          });
          h += "</div>";
        }
        if (sug.length) {
          h += '<div class="mc-cauta__cap"><b>Populare</b></div><div class="mc-cauta__bule">';
          sug.forEach(function (q) { h += '<span class="mc-cauta__bula mc-cauta__bula--pop"><a href="' + urlCautare(q) + '"><svg class="mc-i" aria-hidden="true"><use href="#mc-i-sus"/></svg>' + esc(q) + "</a></span>"; });
          h += "</div>";
        }
        if (!h) return;
        lista.innerHTML = '<div class="mc-cauta__gol">' + h + "</div>"; lista.hidden = false; inp.setAttribute("aria-expanded", "true");
      }
      inp.addEventListener("focus", function () { if (!inp.value.trim()) gol(); });
      inp.addEventListener("click", function () { if (!inp.value.trim() && lista.hidden) gol(); });
      lista.addEventListener("click", function (e) {
        var x = e.target.closest("[data-recent-x]"), s = e.target.closest("[data-recente-sterge]");
        if (x) { e.preventDefault(); var L = recente(); L.splice(+x.getAttribute("data-recent-x"), 1); salveazaRecente(L); if (L.length || sug.length) gol(); else inchide(); inp.focus(); }
        else if (s) { e.preventDefault(); salveazaRecente([]); gol(); inp.focus(); }
      });
      f.addEventListener("submit", function () {
        var q = inp.value.trim(); if (!q) return;
        var L = recente().filter(function (x) { return fara(x.toLowerCase()) !== fara(q.toLowerCase()); }); L.unshift(q); salveazaRecente(L);
        inp.value = normalizeaza(q);
      });
      if (sug.length > 1 && !mmRed) {
        var k = 0;
        setInterval(function () {
          if (d.hidden || d.activeElement === inp || inp.value) return;
          k = (k + 1) % sug.length;
          inp.setAttribute("placeholder", "Caută: " + sug[k]);
        }, 5000);
      }
      var t, ultim = "", ctrl;
      function inchide() { lista.hidden = true; lista.innerHTML = ""; inp.setAttribute("aria-expanded", "false"); }
      inp.addEventListener("input", function () {
        clearTimeout(t);
        var q = normalizeaza(inp.value.trim());
        if (!inp.value.trim()) { gol(); return; }
        if (q.length < 2) { inchide(); return; }
        t = setTimeout(function () {
          if (q === ultim) return;
          ultim = q;
          if (ctrl) ctrl.abort();
          ctrl = window.AbortController ? new AbortController() : null;
          var u = root + "search/suggest.json?q=" + encodeURIComponent(q) +
            "&resources[type]=query,product,collection&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last";
          fetch(u, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (j) {
            var res = (j && j.resources && j.resources.results) || {}, h = "";
            (res.queries || []).slice(0, 4).forEach(function (s) {
              var t = esc(s.text), qn = esc(q);
              var b = t.toLowerCase().indexOf(qn) === 0 ? "<b>" + t.slice(0, qn.length) + "</b>" + t.slice(qn.length) : t;
              h += '<a class="mc-cauta__q" href="' + urlCautare(s.text) + '"><svg class="mc-i" aria-hidden="true"><use href="#mc-i-cauta"/></svg><span>' + b + "</span></a>";
            });
            (res.collections || []).slice(0, 3).forEach(function (c) {
              h += '<a href="' + c.url + '"><span><b>' + esc(c.title) + "</b><small>Categorie</small></span></a>";
            });
            (res.products || []).forEach(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
              if (img) img = img + (img.indexOf("?") > -1 ? "&" : "?") + "width=100";
              h += '<a href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" width="44" height="44" loading="lazy">' : "") +
                "<span>" + esc(p.title) + "<small>" + (p.price ? esc(String(p.price).replace(".", ",")) + " lei" : "") + (p.available === false ? " · stoc epuizat" : "") + "</small></span></a>";
            });
            if (!h) h = "<p>Nu am găsit nimic pentru „" + esc(inp.value.trim()) + "”.</p>";
            else h += '<a class="mc-cauta__tot" href="' + urlCautare(q) + '">Vezi toate rezultatele</a>';
            lista.innerHTML = h; lista.hidden = false; inp.setAttribute("aria-expanded", "true");
          }).catch(function () {});
        }, 220);
      });
      inp.addEventListener("keydown", function (e) { if (e.key === "Escape") inchide(); });
      d.addEventListener("click", function (e) { if (!f.contains(e.target)) inchide(); });
    });
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  /* ——— cronometre (doar spre date reale puse în setări) ——— */
  function doi(n) { return (n < 10 ? "0" : "") + n; }
  function cronometre() {
    var ceasuri = $$("[data-ceas]");
    var termene = $$("[data-termen]");
    if (!ceasuri.length && !termene.length) return;
    function pas() {
      var acum = Date.now() / 1000;
      termene.forEach(function (t) {
        var de = +t.getAttribute("data-de") || 0, pana = +t.getAttribute("data-pana") || 0, dupa = +t.getAttribute("data-dupa") || 0;
        var a = $(".mc-termen__a", t), b = $(".mc-termen__b", t);
        var st = (pana && acum >= de && acum < pana) ? "a" : (pana && dupa && acum >= pana && acum <= dupa) ? "b" : "";
        if (a) a.hidden = st !== "a";
        if (b) b.hidden = st !== "b";
        t.hidden = !st;
      });
      ceasuri.forEach(function (c) {
        var r = Math.floor((+c.getAttribute("data-ceas") || 0) - acum);
        if (r <= 0) {
          var sel = c.getAttribute("data-ascunde");
          var z = sel ? c.closest(sel) : null;
          if (z) z.hidden = true;
          c.textContent = "";
          return;
        }
        var zile = Math.floor(r / 86400), h = Math.floor(r % 86400 / 3600), m = Math.floor(r % 3600 / 60), s = r % 60;
        if (c.classList.contains("mc-ceas--cutii")) {
          c.innerHTML = (zile ? "<i>" + zile + "</i><u>z</u>" : "") + "<i>" + doi(h) + "</i><u>:</u><i>" + doi(m) + "</i><u>:</u><i>" + doi(s) + "</i>";
        } else {
          c.innerHTML = (zile ? "<i>" + zile + "</i> " + (zile === 1 ? "zi" : "zile") + " " : "") + "<i>" + doi(h) + "</i>:<i>" + doi(m) + "</i>:<i>" + doi(s) + "</i>";
        }
      });
    }
    pas();
    setInterval(pas, 1000);
  }

  /* ——— coșul: numărul din antet, bara de jos ——— */
  function actualizeazaCos(c, sare) {
    $$("[data-cos-nr]").forEach(function (el) { el.textContent = c.item_count; if (el.classList.contains("mc-hdr__nr")) el.hidden = !c.item_count; });
    $$("[data-cos-total]").forEach(function (el) { el.textContent = bani(c.total_price); });
    var bar = $("[data-cosbar]");
    if (bar) {
      var era = bar.hidden;
      bar.hidden = !c.item_count;
      if (sare && !mmRed && c.item_count) { bar.classList.remove("mc-sare"); void bar.offsetWidth; bar.classList.add("mc-sare"); }
      if (era && c.item_count && mmRed) bar.classList.remove("mc-sare");
    }
    if (sare && !mmRed) {
      $$("[data-cos-ic]").forEach(function (ic) { ic.classList.remove("mc-sare"); void ic.offsetWidth; ic.classList.add("mc-sare"); });
    }
  }
  function citesteCos() {
    return fetch(root + "cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }
  window.addEventListener("pageshow", function (e) { if (e.persisted) citesteCos().then(function (c) { actualizeazaCos(c, false); }).catch(function () {}); });

  /* ——— pagina de produs ——— */
  function produs() {
    var f = $("[data-adauga]");
    if (!f) return;
    var cant = $("[data-cant] input", f);
    $$("[data-cant-minus], [data-cant-plus]", f).forEach(function (b) {
      b.addEventListener("click", function () {
        var v = parseInt(cant.value, 10) || 1, max = parseInt(cant.getAttribute("max"), 10) || 999;
        v += b.hasAttribute("data-cant-plus") ? 1 : -1;
        cant.value = Math.max(1, Math.min(max, v));
      });
    });
    /* variantele: culorile ca buline, restul ca butoane; prețul, stocul și poza pe variantă */
    var dateV = $("[data-variante]", f), idIn = $("[data-varianta-id]", f);
    if (dateV && idIn) {
      var V = []; try { V = JSON.parse(dateV.textContent); } catch (e) {}
      var grupe = $$("[data-opt]", f), ales = grupe.map(function (g) { var sl = $("[data-opt-sel]", g); if (sl) return sl.value; var b = $('[aria-pressed="true"]', g); return b ? b.getAttribute("data-val") : null; });
      function lei(c) { var l = Math.floor(c / 100), b = c % 100; return l + (b ? "," + doi(b) : "") + " lei"; }
      function gaseste(sel) { return V.filter(function (x) { return x.o.every(function (v, k) { return sel[k] == null || v === sel[k]; }); }); }
      function pretHtml(c) { var lei = Math.floor(c / 100), b = c % 100; return '<span class="mc-pret mc-pret--xl"><b>' + lei + "</b><small>" + (b ? "," + doi(b) : "") + " lei</small></span>"; }
      function aplica(x, mutaPoza) {
        if (!x) return;
        idIn.value = x.id;
        var pr = $("[data-pret]");
        if (pr) pr.innerHTML = pretHtml(x.p) + (x.c > x.p ? "<s>" + bani(x.c) + '</s><span class="mc-insigna mc-insigna--in">-' + bani(x.c - x.p).replace(",00", "") + "</span>" : "");
        var st = $("[data-stoc]");
        if (st) st.innerHTML = !x.a ? '<span class="mc-et mc-et--gri">Stoc epuizat</span>' : (x.s > 0 ? '<span class="mc-et mc-et--mare">În stoc</span>' : "");
        if (x.s > 0) cant.setAttribute("max", x.s); else cant.removeAttribute("max");
        var btn = $("[data-adauga-btn]", f), txt = $("[data-adauga-txt]", f);
        btn.disabled = !x.a; txt.textContent = x.a ? "Adaugă în coș" : "Stoc epuizat";
        grupe.forEach(function (g, k) {
          var val = $("[data-opt-val]", g); if (val) val.textContent = x.o[k];
          var sl = $("[data-opt-sel]", g);
          if (sl) {
            sl.value = x.o[k];
            Array.prototype.forEach.call(sl.options, function (op) {
              var s2 = x.o.slice(); s2[k] = op.value;
              var y = V.filter(function (z) { return z.o.every(function (w, i) { return w === s2[i]; }); })[0];
              op.textContent = op.value + (y ? " · " + lei(y.p) + (y.a ? "" : " · epuizat") : " · indisponibil");
              op.disabled = !y;
            });
          }
          $$("[data-val]", g).forEach(function (b) {
            var v = b.getAttribute("data-val"); b.setAttribute("aria-pressed", v === x.o[k] ? "true" : "false");
            var s2 = x.o.slice(); s2[k] = v;
            var ok = V.some(function (y) { return y.a && y.o.every(function (w, i) { return w === s2[i]; }); });
            b.classList.toggle("is-indisponibil", !ok);
          });
        });
        /* lungimea utilă și prețul pe metru, după opțiunea „Lungime” a variantei */
        var fisa = $("[data-fisa]"), lgo = fisa ? +fisa.getAttribute("data-lg-opt") : -1;
        if (fisa && lgo > -1) {
          var Lm = parseFloat(String(x.o[lgo] || "").replace(",", "."));
          var fl = $("[data-fisa-l]", fisa), fp = $("[data-fisa-pm]", fisa);
          if (Lm >= 1) { if (fl) fl.textContent = String(Lm).replace(".", ",") + " m"; if (fp) fp.textContent = bani(Math.round(x.p / Lm)) + "/m"; }
        }
        if (mutaPoza && x.m) { var gal = $("[data-gal]"); if (gal) { var sl = $$(".mc-gal__s", gal)[x.m - 1]; if (sl) gal.scrollTo({ left: sl.offsetLeft, behavior: "auto" }); } }
        try { var u = new URL(location.href); u.searchParams.set("variant", x.id); history.replaceState(null, "", u); } catch (e) {}
      }
      function alege(k, v) {
        ales[k] = v;
        var exact = gaseste(ales).filter(function (x) { return x.o.every(function (v, i) { return v === ales[i]; }); })[0];
        if (!exact || !exact.a) {
          /* combinația nu există sau e epuizată: varianta disponibilă cu valoarea aleasă care păstrează cele mai multe alegeri */
          var cand = V.filter(function (x) { return x.o[k] === v; }), alt = null, best = -1;
          cand.forEach(function (x) {
            var sc = (x.a ? 100 : 0) + x.o.reduce(function (a, w, i) { return a + (i !== k && w === ales[i] ? 1 : 0); }, 0);
            if (sc > best) { best = sc; alt = x; }
          });
          if (alt) { exact = alt; ales = alt.o.slice(); }
        }
        aplica(exact, true);
      }
      f.addEventListener("click", function (e) {
        var b = e.target.closest("[data-val]"); if (!b) return;
        var k = grupe.indexOf(b.closest("[data-opt]")); if (k > -1) alege(k, b.getAttribute("data-val"));
      });
      f.addEventListener("change", function (e) {
        if (!e.target.matches("[data-opt-sel]")) return;
        var k = grupe.indexOf(e.target.closest("[data-opt]")); if (k > -1) alege(k, e.target.value);
      });
      aplica(V.filter(function (x) { return String(x.id) === String(idIn.value); })[0], true);
    }
    var msg = $("[data-adauga-mesaj]", f);
    f.addEventListener("submit", function (e) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = $("[data-adauga-btn]", f), txt = $("[data-adauga-txt]", f), vechi = txt.textContent;
      btn.disabled = true; txt.textContent = "Se adaugă…";
      fetch(root + "cart/add.js", { method: "POST", headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" }, body: new FormData(f) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, j: j }; }); })
        .then(function (x) {
          if (!x.ok) {
            msg.className = "mc-pp__mesaj is-eroare";
            var desc = x.j && typeof x.j.description === "string" ? x.j.description : "";
            msg.textContent = desc || (x.status === 422 ? "Nu putem adăuga această cantitate: în stoc sunt mai puține bucăți (sau le ai deja în coș)." : "Nu s-a putut adăuga în coș. Încearcă din nou.");
            msg.hidden = false; btn.disabled = false; txt.textContent = vechi;
            return;
          }
          return citesteCos().then(function (c) {
            actualizeazaCos(c, true);
            txt.textContent = "Adăugat în coș ✓";
            if (!arataAdaugat(x.j, c)) {
              msg.className = "mc-pp__mesaj";
              msg.innerHTML = "Produsul e în coș (" + c.item_count + (c.item_count === 1 ? " produs" : " produse") + ", " + bani(c.total_price) + '). <a href="' + root + 'cart">Finalizează comanda ›</a>';
              msg.hidden = false;
            }
            setTimeout(function () { btn.disabled = false; txt.textContent = vechi; }, 1800);
          });
        })
        .catch(function () { f.submit(); });
    });

    /* galeria: numărul pozei + miniaturile */
    var gal = $("[data-gal]");
    if (gal) {
      var nr = $("[data-gal-nr]"), mini = $$("[data-gal-mini] a"), sl = $$(".mc-gal__s", gal);
      var curent = function () { return Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth)); };
      gal.addEventListener("scroll", function () {
        window.requestAnimationFrame(function () {
          var i = curent();
          if (nr) nr.textContent = (i + 1) + " / " + sl.length;
          mini.forEach(function (m, k) { m.classList.toggle("is-on", k === i); });
        });
      }, { passive: true });
      mini.forEach(function (m, k) {
        m.addEventListener("click", function (e) {
          e.preventDefault();
          gal.scrollTo({ left: k * gal.clientWidth, behavior: mmRed ? "auto" : "smooth" });
        });
      });
    }
  }

  /* ——— „Vezi mai multe”: pagina următoare, prin Section Rendering API. C1: adresa primește ?page=N (replaceState), iar la
     revenirea cu „Înapoi” se aduc la loc paginile de dinainte și poziția (sessionStorage), ca la Horizon (paginated-list.js) ——— */
  function cheieLista(u) { var x = new URL(u, location.href); x.searchParams.delete("page"); x.searchParams.delete("section_id"); x.hash = ""; return x.pathname + x.search; }
  function stareLista() { try { return JSON.parse(sessionStorage.getItem("mc-lista") || "null"); } catch (e) { return null; } }
  function paginaLista(sec, nr) {
    var u = new URL(location.href); u.hash = "";
    if (nr > 1) u.searchParams.set("page", nr); else u.searchParams.delete("page");
    u.searchParams.set("section_id", sec.getAttribute("data-lista") || sec.getAttribute("data-flux"));
    return fetch(u.toString()).then(function (r) { if (!r.ok) throw r.status; return r.text(); }).then(function (h) {
      var g = new DOMParser().parseFromString(h, "text/html").querySelector("[data-lista-grila], [data-flux-grila]");
      return g ? Array.prototype.slice.call(g.children) : [];
    });
  }
  function listaRevenire() {
    var sec = $("[data-lista]"), grila = sec && $("[data-lista-grila]", sec); if (!grila) return;
    var u = new URL(location.href), pag = +u.searchParams.get("page") || 1, st = stareLista(), cheie = cheieLista(location.href);
    /* plecarea de pe listă: ține minte poziția */
    window.addEventListener("pagehide", function () {
      var s2 = stareLista() || {}; if (s2.k !== cheie) s2 = { k: cheie, de: pag, pana: pag };
      s2.y = window.scrollY; try { sessionStorage.setItem("mc-lista", JSON.stringify(s2)); } catch (e) {}
    });
    if (pag < 2) return;
    var de = st && st.k === cheie && st.pana === pag && st.de < pag ? st.de : pag;
    sec.setAttribute("data-de", de);
    if (de < pag) {
      /* venim înapoi: aducem paginile de.. pag-1 înaintea celei curente, apoi derulăm unde era */
      if ("scrollRestoration" in history) history.scrollRestoration = "manual";
      var pagini = []; for (var i = de; i < pag; i++) pagini.push(i);
      Promise.all(pagini.map(function (i) { return paginaLista(sec, i); })).then(function (lst) {
        var primul = grila.firstChild;
        lst.forEach(function (copii) { copii.forEach(function (c) { grila.insertBefore(d.importNode(c, true), primul); }); });
        if (st.y) window.scrollTo(0, st.y);
      }).catch(function () {});
    } else {
      /* adresă cu ?page=N deschisă direct: buton pentru produsele de dinainte */
      var b = d.createElement("button");
      b.type = "button"; b.className = "mc-btn mc-btn--contur mc-btn--mic mc-lista__inainte"; b.textContent = "‹ Vezi produsele de dinainte";
      grila.parentNode.insertBefore(b, grila);
      b.addEventListener("click", function () {
        var p0 = +sec.getAttribute("data-de") || pag; if (p0 < 2) { b.remove(); return; }
        b.disabled = true;
        paginaLista(sec, p0 - 1).then(function (copii) {
          var h0 = d.documentElement.scrollHeight, primul = grila.firstChild;
          copii.forEach(function (c) { grila.insertBefore(d.importNode(c, true), primul); });
          window.scrollBy(0, d.documentElement.scrollHeight - h0);
          sec.setAttribute("data-de", p0 - 1); b.disabled = false;
          var s2 = stareLista() || {}; s2.k = cheie; s2.de = p0 - 1; s2.pana = +new URL(location.href).searchParams.get("page") || pag;
          try { sessionStorage.setItem("mc-lista", JSON.stringify(s2)); } catch (e) {}
          if (p0 - 1 < 2) b.remove();
        }).catch(function () { b.disabled = false; });
      });
    }
  }
  function maiMulte() {
    d.addEventListener("click", function (e) {
      var a = e.target.closest("[data-flux-mai], [data-lista-mai]");
      if (!a || !window.fetch || !window.DOMParser) return;
      var sec = a.closest("[data-flux], [data-lista]");
      if (!sec) return;
      e.preventDefault();
      var id = sec.getAttribute("data-flux") || sec.getAttribute("data-lista");
      var u;
      try { u = new URL(a.href, location.href); } catch (er) { return; }
      u.hash = "";
      u.searchParams.set("section_id", id);
      a.classList.add("is-incarca");
      fetch(u.toString()).then(function (r) { return r.text(); }).then(function (h) {
        var doc = new DOMParser().parseFromString(h, "text/html");
        var grilaNoua = doc.querySelector("[data-flux-grila], [data-lista-grila]");
        var grila = $("[data-flux-grila], [data-lista-grila]", sec);
        if (grilaNoua && grila) {
          var primul = null;
          Array.prototype.slice.call(grilaNoua.children).forEach(function (c) {
            var n = d.importNode(c, true);
            grila.appendChild(n);
            if (!primul) primul = n;
          });
          if (primul) { var l = primul.querySelector("a, [href]") || primul; try { l.focus({ preventScroll: true }); } catch (er) {} }
        }
        if (sec.hasAttribute("data-lista")) {
          var nr = +u.searchParams.get("page") || 0;
          if (nr > 1) {
            try {
              var adr = new URL(location.href); adr.searchParams.set("page", nr); adr.hash = "";
              history.replaceState(history.state, "", adr.toString());
              var de = +sec.getAttribute("data-de") || +(new URL(a.href, location.href)).searchParams.get("page") - 1 || 1;
              if (!sec.hasAttribute("data-de")) sec.setAttribute("data-de", de);
              sessionStorage.setItem("mc-lista", JSON.stringify({ k: cheieLista(location.href), de: +sec.getAttribute("data-de"), pana: nr, y: window.scrollY }));
            } catch (er) {}
          }
        }
        var navNou = doc.querySelector("[data-flux-nav], [data-lista-nav]");
        var nav = $("[data-flux-nav], [data-lista-nav]", sec);
        if (nav) {
          if (navNou) nav.replaceWith(d.importNode(navNou, true));
          else nav.remove();
        }
      }).catch(function () { location.href = a.href; });
    });
  }

  /* ——— coșul: + / − / șterge fără reîncărcare ——— */
  function cos() {
    var s = $("[data-cos-sectiune]");
    if (!s) return;
    d.addEventListener("click", function (e) {
      var a = e.target.closest("[data-cos-schimba]");
      if (!a || !window.fetch) return;
      e.preventDefault();
      var sec = $("[data-cos-sectiune]"), id = sec.getAttribute("data-cos-sectiune");
      sec.classList.add("is-incarca");
      fetch(root + "cart/change.js", {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: +a.getAttribute("data-cos-schimba"), quantity: +a.getAttribute("data-cant-noua"), sections: [id] })
      }).then(function (r) { return r.json(); }).then(function (c) {
        var h = c.sections && c.sections[id];
        if (h) {
          var doc = new DOMParser().parseFromString(h, "text/html"), nou = doc.querySelector("[data-cos-sectiune]");
          if (nou) { var n2 = d.importNode(nou, true); sec.replaceWith(n2); livrare(n2); }
        } else { location.reload(); return; }
        if (typeof c.item_count === "number") actualizeazaCos(c, false);
      }).catch(function () { location.href = a.href; });
    });
  }

  /* ——— diverse ——— */
  function diverse() {
    d.addEventListener("change", function (e) {
      if (e.target.matches("[data-auto-trimite]")) { var f = e.target.form; if (f) f.submit(); }
    });
    d.addEventListener("submit", function (e) {
      if (!e.target.matches("[data-filtre]")) return;
      $$("input[type=number]", e.target).forEach(function (i) { if (i.value === "") i.disabled = true; });
    });
    $$("[data-tabs]").forEach(function (t) {
      var a = $(".is-activ", t);
      if (a && a.offsetLeft + a.offsetWidth > t.clientWidth) t.scrollLeft = a.offsetLeft - 24;
    });
  }

  /* ——— secțiunile interactive: scriptul lor se încarcă abia când ajung aproape de ecran ——— */
  var incarcate = {};
  function incarca(src) {
    if (!incarcate[src]) incarcate[src] = new Promise(function (ok) {
      var s = d.createElement("script"); s.src = src; s.defer = true; s.onload = ok; s.onerror = ok; d.head.appendChild(s);
    });
    return incarcate[src];
  }
  function lenese() {
    d.addEventListener("click", function (e) {
      var b = e.target.closest("[data-joc-porneste]"); if (!b) return;
      var sc = b.closest("[data-joc]"); if (!sc) return;
      incarca(sc.getAttribute("data-js")).then(function () { if (window.mcJoc) window.mcJoc(sc); });
    });
    var el = $$("[data-mc-js]");
    if (!el.length) return;
    if (!("IntersectionObserver" in window)) { el.forEach(function (x) { incarca(x.getAttribute("data-mc-js")); }); return; }
    var io = new IntersectionObserver(function (xs) {
      xs.forEach(function (x) { if (x.isIntersecting) { io.unobserve(x.target); incarca(x.target.getAttribute("data-mc-js")); } });
    }, { rootMargin: "600px 0px" });
    el.forEach(function (x) { io.observe(x); });
  }
  /* ——— zilele până la Crăciun în banda de sus ——— */
  function zileCraciun() {
    $$("[data-zile-craciun]").forEach(function (el) {
      var t = +el.getAttribute("data-zile-craciun"), r = Math.ceil((t - Date.now() / 1000) / 86400);
      if (r > 0) el.textContent = r;
    });
  }

  /* ——— „Se potrivesc perfect împreună”: totalul celor bifate + un singur „Adaugă toate în coș” ——— */
  function impreuna() {
    var s = $("[data-impreuna]"); if (!s) return;
    function bifate() { return $$("[data-imp-curent], [data-imp]:checked", s); }
    function total() {
      var b = bifate(), sum = 0; b.forEach(function (c) { sum += +c.getAttribute("data-pret"); });
      var n = $("[data-imp-nr]", s), t = $("[data-imp-total]", s); if (n) n.textContent = b.length; if (t) t.textContent = bani(sum);
    }
    s.addEventListener("change", total); total();
    var btn = $("[data-imp-adauga]", s), txt = $("[data-imp-txt]", s), msg = $("[data-imp-mesaj]", s);
    btn.addEventListener("click", function () {
      var cur = $("[data-varianta-id]"), items = bifate().map(function (c) {
        var id = c.hasAttribute("data-imp-curent") && cur ? cur.value : c.getAttribute("data-id"); return { id: +id, quantity: 1 };
      });
      var vechi = txt.textContent; btn.disabled = true; txt.textContent = "Se adaugă…";
      fetch(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (x) {
          if (!x.ok) { msg.className = "mc-pp__mesaj is-eroare"; msg.textContent = (x.j && x.j.description) || "Nu s-au putut adăuga toate. Încearcă din nou."; msg.hidden = false; btn.disabled = false; txt.textContent = vechi; return; }
          return citesteCos().then(function (c) {
            actualizeazaCos(c, true);
            msg.className = "mc-pp__mesaj"; msg.innerHTML = "Le-am pus în coș (" + c.item_count + " produse, " + bani(c.total_price) + '). <a href="' + root + 'cart">Finalizează comanda ›</a>'; msg.hidden = false;
            txt.textContent = "Adăugate în coș ✓"; setTimeout(function () { btn.disabled = false; txt.textContent = vechi; }, 1800);
          });
        }).catch(function () { btn.disabled = false; txt.textContent = vechi; });
    });
  }

  /* ——— oferta din dreapta (doar cu reducere reală; apare după câteva secunde; ține minte închiderea) ——— */
  function ofertaPop() {
    var p = $("[data-pop]"); if (!p) return;
    var id = p.getAttribute("data-pop"), inchis = "";
    try { inchis = localStorage.getItem("mc-pop-x") || ""; } catch (e) {}
    if (inchis === id) return;
    setTimeout(function () { p.hidden = false; if (!mmRed) p.classList.add("is-intra"); }, (+p.getAttribute("data-pop-dupa") || 8) * 1000);
    $("[data-pop-x]", p).addEventListener("click", function () { p.hidden = true; try { localStorage.setItem("mc-pop-x", id); } catch (e) {} });
    var b = $("[data-pop-adauga]", p), t = $("[data-pop-txt]", p);
    b.addEventListener("click", function () {
      b.disabled = true; t.textContent = "Se adaugă…";
      fetch(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: +b.getAttribute("data-pop-adauga"), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw 0; return citesteCos(); })
        .then(function (c) { actualizeazaCos(c, true); t.textContent = "Adăugat ✓"; setTimeout(function () { p.hidden = true; try { localStorage.setItem("mc-pop-x", id); } catch (e) {} }, 1600); })
        .catch(function () { b.disabled = false; t.textContent = "Adaugă în coș"; });
    });
  }

  /* ——— B2: foaia de jos după „Adaugă în coș”: produsul, totalul cu transportul, data, accesoriile (nebifate) ——— */
  function sumeAdaugat(dl, c) {
    var tr = +dl.getAttribute("data-transport") || 0, sum = $("[data-prag-lim]", dl), prag = sum ? +sum.getAttribute("data-prag-lim") || 0 : 0;
    var gratuit = prag > 0 && c.total_price >= prag, trEf = gratuit ? 0 : tr;
    var nr = $("[data-ad-nr]", dl), st = $("[data-ad-subt]", dl), tot = $("[data-ad-total]", dl), trd = $("[data-ad-tr]", dl);
    var orig = c.original_total_price || c.total_price, red = Math.max(0, orig - c.total_price);
    if (nr) nr.textContent = c.item_count;
    if (st) st.textContent = bani(orig);
    var rr = $("[data-ad-red-r]", dl);
    if (rr) {
      rr.hidden = !red; $("[data-ad-red]", dl).textContent = "−" + bani(red);
      var tit = (c.cart_level_discount_applications || []).map(function (x) { return x.title; }).filter(Boolean);
      (c.items || []).forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { var t = a.discount_application && a.discount_application.title; if (t && tit.indexOf(t) < 0) tit.push(t); }); });
      $("[data-ad-red-t]", dl).textContent = tit.length ? tit.join(", ") : "Reducere";
    }
    if (trd) trd.innerHTML = gratuit ? '<b class="mc-verde">Gratuit</b>' : bani(tr);
    if (tot) tot.textContent = bani(c.total_price + trEf);
    pragActualizeaza(dl, c.total_price);
    trepteActualizeaza(dl, c.item_count);
  }
  /* bara până la livrarea gratuită (pe totalul după reduceri) */
  function pragActualizeaza(r, total) {
    $$("[data-prag]", r).forEach(function (el) {
      var prag = +el.getAttribute("data-prag") || 0; if (!prag) return;
      var lipsa = prag - total, t = $("[data-prag-t]", el), i = $("[data-prag-i]", el);
      el.classList.toggle("is-gata", lipsa <= 0);
      if (t) t.innerHTML = lipsa <= 0 ? '<svg class="mc-i" aria-hidden="true"><use href="#mc-i-check"/></svg>Livrarea e gratuită' : "Mai ai <b>" + bani(lipsa) + "</b> până la livrarea gratuită";
      if (i) i.style.width = Math.min(100, Math.round(total * 100 / prag)) + "%";
    });
  }
  /* „Mai adaugă 1 produs și primești −10%” */
  function trepteActualizeaza(r, nr) {
    $$("[data-trepte]", r).forEach(function (el) {
      var u = $("[data-trepte-urm]", el); if (!u) return;
      var T = []; try { T = JSON.parse(el.getAttribute("data-trepte")); } catch (e) {}
      var urm = T.filter(function (x) { return nr < x[0]; })[0], atins = T.filter(function (x) { return nr >= x[0]; }).pop();
      if (urm && nr > 0) { var l = urm[0] - nr; u.innerHTML = "Mai adaugă <b>" + l + (l === 1 ? " produs" : " produse") + "</b> și primești <b>−" + urm[1] + "%</b>."; }
      else if (atins) u.innerHTML = '<svg class="mc-i" aria-hidden="true"><use href="#mc-i-check"/></svg>Ai reducerea de −' + atins[1] + "% pe tot coșul.";
      else u.innerHTML = "";
    });
  }
  function arataAdaugat(it, c) {
    var dl = d.getElementById("mc-adaugat");
    if (!dl || !dl.showModal || !it || !it.id) return false;
    var img = $("[data-ad-img]", dl), u = it.image || (it.featured_image && it.featured_image.url) || "";
    img.innerHTML = u ? '<img src="' + esc(u) + (u.indexOf("?") > -1 ? "&" : "?") + 'width=200" alt="" width="88" height="88">' : "";
    $("[data-ad-t]", dl).textContent = it.product_title || it.title || "";
    var v = $("[data-ad-v]", dl);
    v.hidden = !!it.product_has_only_default_variant || !it.variant_title;
    v.textContent = it.variant_title || "";
    var linie = (c.items || []).filter(function (x) { return x.key === it.key; })[0] || it;
    $("[data-ad-pret]", dl).innerHTML = "<b>" + bani(it.final_price) + "</b>" + (linie.quantity > 1 ? " · " + linie.quantity + " buc. în coș" : "");
    sumeAdaugat(dl, c);
    livrare(dl);
    var m = $("[data-ad-mesaj]", dl); if (m) m.hidden = true;
    deschide(dl);
    return true;
  }
  function adaugatAccesorii() {
    var dl = d.getElementById("mc-adaugat"); if (!dl) return;
    dl.addEventListener("click", function (e) {
      var b = e.target.closest("[data-ad-acc]"); if (!b || b.disabled) return;
      var vechi = b.textContent; b.disabled = true; b.textContent = "Se adaugă…";
      fetch(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: +b.getAttribute("data-ad-acc"), quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (x) {
          if (!x.ok) { var m = $("[data-ad-mesaj]", dl); m.className = "mc-pp__mesaj is-eroare"; m.textContent = (x.j && x.j.description) || "Nu s-a putut adăuga."; m.hidden = false; b.disabled = false; b.textContent = vechi; return; }
          return citesteCos().then(function (c) { actualizeazaCos(c, false); sumeAdaugat(dl, c); b.textContent = "Adăugat ✓"; b.classList.add("is-ok"); });
        }).catch(function () { b.disabled = false; b.textContent = vechi; });
    });
  }

  /* ——— B1: data estimată de livrare, din ora României ——— */
  var ZILE = ["duminică", "luni", "marți", "miercuri", "joi", "vineri", "sâmbătă"];
  var LUNI = ["ian.", "feb.", "mar.", "apr.", "mai", "iun.", "iul.", "aug.", "sept.", "oct.", "nov.", "dec."];
  function acumRO() {
    var t = new Date();
    try {
      var o = {}; new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Bucharest", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
        .formatToParts(t).forEach(function (p) { o[p.type] = p.value; });
      return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24 };
    } catch (e) { return { y: t.getFullYear(), m: t.getMonth() + 1, d: t.getDate(), h: t.getHours() }; }
  }
  function livrare(r) {
    $$("[data-livrare-data]", r).forEach(function (el) {
      var ora = +el.getAttribute("data-ora") || 12, mn = +el.getAttribute("data-min"), mx = +el.getAttribute("data-max") || 3;
      if (isNaN(mn)) mn = 1; if (mx < mn) mx = mn;
      var lib = (el.getAttribute("data-libere") || "").split(/\s+/).filter(Boolean);
      var stop = +el.getAttribute("data-stop") || 0, reia = +el.getAttribute("data-reia") || 0, now = Date.now() / 1000;
      if (stop && reia && now >= stop && now <= reia) {
        var rt = el.getAttribute("data-reia-text"); if (rt) { el.innerHTML = "<b>" + esc(rt) + "</b>"; el.hidden = false; }
        return;
      }
      var a = acumRO(), azi = new Date(Date.UTC(a.y, a.m - 1, a.d));
      function iso(x) { return x.toISOString().slice(0, 10); }
      function lucru(x) { var w = x.getUTCDay(); return w !== 0 && w !== 6 && lib.indexOf(iso(x)) < 0; }
      function urm(x) { var y = new Date(x.getTime()); do { y.setUTCDate(y.getUTCDate() + 1); } while (!lucru(y)); return y; }
      var pleacaAzi = lucru(azi) && a.h < ora, plec = pleacaAzi ? azi : urm(azi);
      function plus(x, n) { var y = x; for (var i = 0; i < n; i++) y = urm(y); return y; }
      var d1 = plus(plec, mn), d2 = plus(plec, mx);
      function zi(x, luna) { return ZILE[x.getUTCDay()] + " " + x.getUTCDate() + (luna ? " " + LUNI[x.getUTCMonth()] : ""); }
      var t = iso(d1) === iso(d2) ? "Ajunge " + zi(d1, true) :
        "Ajunge între " + zi(d1, d1.getUTCMonth() !== d2.getUTCMonth()) + " și " + zi(d2, true);
      var cand = pleacaAzi ? "dacă comanzi azi până la " + ora + ":00" : "comanda pleacă " + (plec.getTime() - azi.getTime() === 864e5 ? "mâine" : zi(plec, false));
      el.innerHTML = '<svg class="mc-i" aria-hidden="true"><use href="#mc-i-ceas"/></svg><span><b>' + esc(t) + "</b> <small>" + esc(cand) + " · estimare</small></span>";
      el.hidden = false;
    });
  }

  /* ——— B6: „E cadou” în coș (atribut al comenzii, salvat pe loc) ——— */
  function cadou() {
    d.addEventListener("change", function (e) {
      if (!e.target.matches("[data-cadou]")) return;
      var val = e.target.checked ? e.target.value : "";
      fetch(root + "cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ attributes: { "E cadou": val } }) }).catch(function () {});
    });
  }

  /* ——— C2: „Vezi N produse” în foaia de filtre, cu numărul adus la fiecare bifă (secțiunea mc-numar) ——— */
  var numere = {};
  function numar(u) {
    var k = u.toString();
    if (numere[k] != null) return Promise.resolve(numere[k]);
    try { var ss = sessionStorage.getItem("mc-n:" + k); if (ss != null) { numere[k] = +ss; return Promise.resolve(+ss); } } catch (e) {}
    return fetch(k).then(function (r) { if (!r.ok) throw r.status; return r.text(); }).then(function (h) {
      var m = h.match(/data-n>(\d+)</); if (!m) throw 0;
      numere[k] = +m[1]; try { sessionStorage.setItem("mc-n:" + k, m[1]); } catch (e) {}
      return +m[1];
    });
  }
  function mii(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, "."); }
  function produse(n) { var r = n % 100; return mii(n) + (n === 1 ? " produs" : (n >= 20 && (r >= 20 || r === 0) ? " de produse" : " produse")); }
  function filtreNumar() {
    $$("[data-filtre]").forEach(function (f) {
      var b = $("[data-filtre-n]", f), dl = $("dialog", f); if (!b || !dl) return;
      var t, vechi = b.textContent;
      function numara() {
        clearTimeout(t);
        t = setTimeout(function () {
          var u = new URL(location.pathname, location.href);
          new FormData(f).forEach(function (v, k) { if (v !== "" && k !== "sort_by") u.searchParams.append(k, v); });
          u.searchParams.set("section_id", "mc-numar");
          b.classList.add("is-incarca");
          numar(u).then(function (n) {
            b.classList.remove("is-incarca");
            b.textContent = n === 0 ? "Niciun produs" : "Vezi " + produse(n); b.disabled = n === 0;
          }).catch(function () { b.classList.remove("is-incarca"); b.textContent = vechi; b.disabled = false; });
        }, 300);
      }
      dl.addEventListener("change", numara);
      dl.addEventListener("input", function (e) { if (e.target.type === "number") numara(); });
      f.addEventListener("click", function (e) { if (e.target.closest("[data-deschide]")) numara(); });
    });
  }

  /* ——— C3: filtrele rapide: păstrează filtrele din adresă și primesc numărul; la 0 dispar ——— */
  function rapide() {
    var r = $("[data-rapide]"); if (!r) return;
    var cur = new URLSearchParams(location.search); cur.delete("page"); cur.delete("section_id");
    var coada = [];
    $$("[data-rapid]", r).forEach(function (a) {
      var u; try { u = new URL(a.href, location.href); } catch (e) { return; }
      var pret = a.getAttribute("data-rapid") === "pret";
      if (!a.classList.contains("is-activ") || !pret) {
        cur.forEach(function (v, k) {
          if (pret && /^filter\.v\.price\./.test(k)) return;
          if (!u.searchParams.has(k) || k.indexOf("filter.") === 0 && u.searchParams.getAll(k).indexOf(v) < 0) u.searchParams.append(k, v);
        });
        a.href = u.toString();
      }
      if (a.hasAttribute("data-rapid-numar")) coada.push(a);
    });
    var act = $(".is-activ", r); if (act && act.offsetLeft + act.offsetWidth > r.clientWidth) r.scrollLeft = act.offsetLeft - 12;
    function urm() {
      var a = coada.shift(); if (!a) return;
      var u = new URL(a.href); u.searchParams.delete("sort_by"); u.searchParams.set("section_id", "mc-numar");
      numar(u).then(function (n) {
        if (n === 0) a.hidden = true; else { var s = $("[data-rapid-n]", a); if (s) s.textContent = mii(n); }
        setTimeout(urm, 120);
      }).catch(function () { setTimeout(urm, 400); });
    }
    if ("requestIdleCallback" in window) requestIdleCallback(urm, { timeout: 1500 }); else setTimeout(urm, 300);
  }

  /* ——— C7: banda și tab-urile se ascund la derularea în jos (listă, căutare, produs) și revin la derularea în sus ——— */
  function ascundeLaDerulare() {
    var b = d.body.classList;
    if (!b.contains("mc-t-collection") && !b.contains("mc-t-product") && !b.contains("mc-t-search")) return;
    var h = d.documentElement, y0 = window.scrollY, ocupat = false;
    window.addEventListener("scroll", function () {
      if (ocupat) return; ocupat = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY, dy = y - y0;
        if (y < 140) { h.classList.remove("mc-ascuns"); y0 = y; }
        else if (dy > 10) { h.classList.add("mc-ascuns"); y0 = y; }
        else if (dy < -10) { h.classList.remove("mc-ascuns"); y0 = y; }
        ocupat = false;
      });
    }, { passive: true });
  }

  /* ——— C8: „‹ Înapoi la colecție” (revine exact unde era lista) + „Văzute recent” (doar în telefon) ——— */
  function inapoi() {
    var a = $("[data-inapoi]"); if (!a) return;
    var ref = null; try { ref = new URL(d.referrer); } catch (e) {}
    var acelasi = ref && ref.host === location.host;
    if (a.hidden) {
      if (!acelasi || !/^\/(search|collections)/.test(ref.pathname) || /\/products\//.test(ref.pathname)) return;
      a.hidden = false;
      a.lastChild.textContent = ref.pathname.indexOf("/search") === 0 ? "Înapoi la rezultate" : "Înapoi la listă";
      a.href = ref.href;
    }
    a.addEventListener("click", function (e) {
      var tinta = new URL(a.href, location.href).pathname.replace(/\/$/, "");
      if (acelasi && history.length > 1 && ref.pathname.indexOf(tinta) === 0 && !/\/products\//.test(ref.pathname)) { e.preventDefault(); history.back(); }
    });
  }
  function vazute() {
    var L = []; try { L = JSON.parse(localStorage.getItem("mc-vazute") || "[]"); } catch (e) {}
    var cur = $("[data-vazut]"), curU = null;
    if (cur) {
      try {
        var o = JSON.parse(cur.textContent); curU = o.u;
        L = L.filter(function (x) { return x && x.u !== o.u; }); L.unshift({ u: o.u, t: o.t, i: o.i });
        L = L.slice(0, 12); localStorage.setItem("mc-vazute", JSON.stringify(L));
      } catch (e) {}
    }
    $$("[data-vazute]").forEach(function (s) {
      var n = +s.getAttribute("data-vazute") || 10, xs = L.filter(function (x) { return x && x.u && x.u !== curU; }).slice(0, n);
      if (!xs.length) return;
      $("[data-vazute-l]", s).innerHTML = xs.map(function (x) {
        var img = x.i ? '<img src="' + esc(x.i) + '" alt="" width="150" height="150" loading="lazy">' : "";
        return '<a class="mc-vaz__c" href="' + esc(x.u) + '"><span class="mc-vaz__img">' + img + '</span><span class="mc-vaz__t">' + esc(x.t) + "</span></a>";
      }).join("");
      s.hidden = false;
      var b = $("[data-vazute-sterge]", s);
      if (b) b.addEventListener("click", function () { try { localStorage.setItem("mc-vazute", JSON.stringify(curU ? L.slice(0, 1) : [])); } catch (e) {} s.hidden = true; });
    });
  }

  function start() {
    banda(); dialoguri(); cautare(); cronometre(); produs(); maiMulte(); cos(); diverse(); lenese(); zileCraciun(); impreuna(); ofertaPop();
    livrare(d); adaugatAccesorii(); cadou(); filtreNumar(); rapide(); ascundeLaDerulare(); inapoi(); vazute(); listaRevenire();
  }
  if (d.readyState === "loading") d.addEventListener("DOMContentLoaded", start); else start();
})();
